import React from 'react';
import VideoPanel from './VideoPanel';

const ArchiveVideoPanel = (props) => {
  return (<VideoPanel  {...props}/>)
}

export default ArchiveVideoPanel
